import { anyOf, objectOf } from "@altostra/type-validations";
import { number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult =
  anyOf(
    objectOf({
      report_dt: string,
      best_uplift: number,
      personalized_uplift: number,
      random_reward: number,
      best_reward: number,
      personalized_reward: number,
    }),
    nullValidation
  ) as (
    value: unknown
  ) => value is GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult;
